// extracted by mini-css-extract-plugin
module.exports =  {"header-rating":"XCA6ncx","headerRating":"XCA6ncx","header-rating-space-between":"M4oR7IS","headerRatingSpaceBetween":"M4oR7IS"};